import ApiConnector from "@/repository/connector";

class Organizations {
  get = async () => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/core/organizations/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Organizations()